import { colors } from '@scouts/ui'

import {
    CompanyDTO,
    SubscriptionTiers,
    SubscriptionTierType,
    SubscriptionTierVersion,
    SubscriptionTierVersions,
    VariantType,
} from '@/models'

import { getSubscriptionTierDetails } from './subscription-tiers'
import { getIsExistingCompanyVariant } from './variant'

type CompanyTierDetail = {
    tier: SubscriptionTiers
    name: string
    description: string
    color: string
    listTitle: string
    includes: string[]
    shouldHideInPaywall?: boolean
    invoiceLimit?: number
}

type CompanyTierVersions = Record<SubscriptionTierVersion, CompanyTierDetail[]>

const NEW_COMPANY_TIERS_DETAILS: CompanyTierVersions = {
    [SubscriptionTierVersions.Original]: [
        {
            tier: SubscriptionTierType.Companies,
            name: 'Empresas',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.March2024]: [
        {
            tier: SubscriptionTierType.Companies,
            name: 'Empresas',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.April2024]: [
        {
            tier: SubscriptionTierType.Companies10,
            name: 'Empresas 10',
            description:
                'Tu asesor se encargará de la creación de tu sociedad y de los impuestos. Incluye hasta 10 facturas al mes, de sobra mientras empiezas. Si después necesitas más, podrás cambiar de plan.',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.accent,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.Feb2025]: [
        {
            tier: SubscriptionTierType.Companies10,
            name: 'Empresas 10',
            description:
                'Tu asesor se encargará de la creación de tu sociedad y de los impuestos. Incluye hasta 10 facturas al mes, de sobra mientras empiezas. Si después necesitas más, podrás cambiar de plan.',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies20,
            name: 'Empresas 20',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.accent,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies100,
            name: 'Empresas 100',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.Oct2025]: [
        {
            tier: SubscriptionTierType.Companies20,
            name: 'Empresas 20',
            description:
                'Tu asesor se encargará de la creación de tu sociedad y de los impuestos. Incluye hasta 20 facturas al mes, de sobra mientras empiezas. Si después necesitas más, podrás cambiar de plan.',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies100,
            name: 'Empresas 100',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'La ayuda que necesitas para arrancar',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Trámites para crear la empresa',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
}

const EXISTING_COMPANY_TIERS_DETAILS: CompanyTierVersions = {
    [SubscriptionTierVersions.Original]: [
        {
            tier: SubscriptionTierType.Companies,
            name: 'Empresas',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.March2024]: [
        {
            tier: SubscriptionTierType.Companies,
            name: 'Empresas',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
        },
    ],
    [SubscriptionTierVersions.April2024]: [
        {
            tier: SubscriptionTierType.Companies10,
            name: 'Empresas 10',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 10,
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.accent,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 50,
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 200,
        },
    ],
    [SubscriptionTierVersions.Feb2025]: [
        {
            tier: SubscriptionTierType.Companies10,
            name: 'Empresas 10',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 10,
        },
        {
            tier: SubscriptionTierType.Companies20,
            name: 'Empresas 20',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.accent,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 20,
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 50,
        },
        {
            tier: SubscriptionTierType.Companies100,
            name: 'Empresas 100',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 100,
            shouldHideInPaywall: true,
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.highlight,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 200,
            shouldHideInPaywall: true,
        },
    ],
    [SubscriptionTierVersions.Oct2025]: [
        {
            tier: SubscriptionTierType.Companies20,
            name: 'Empresas 20',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.affirm,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 20,
        },
        {
            tier: SubscriptionTierType.Companies50,
            name: 'Empresas 50',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.note,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 50,
        },
        {
            tier: SubscriptionTierType.Companies100,
            name: 'Empresas 100',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 100,
        },
        {
            tier: SubscriptionTierType.Companies200,
            name: 'Empresas 200',
            description: 'Todo lo que necesitas para tu día a día',
            color: colors.surface.neutral,
            listTitle: 'Incluye',
            includes: [
                'Ayuda para cambiarte de gestoría',
                'Gestión de todos los impuestos de la empresa',
                'Programa de facturación y contabilidad online',
            ],
            invoiceLimit: 200,
            shouldHideInPaywall: true,
        },
    ],
}

/**
 * Gets the details of a company subscription tier based on 3 criteria: the variant (existing or new company), the subscription tier and its version
 */
export const getCompanyTierDetails = ({
    currentTierVersion,
    subscriptionTier,
    variant,
}: {
    currentTierVersion: SubscriptionTierVersion
    subscriptionTier: SubscriptionTiers
    variant: VariantType | null | undefined
}) => {
    const subscriptionTiersDetails = getIsExistingCompanyVariant(variant)
        ? EXISTING_COMPANY_TIERS_DETAILS
        : NEW_COMPANY_TIERS_DETAILS

    return getSubscriptionTierDetails({
        currentTierVersion,
        subscriptionTier,
        subscriptionTiersDetails,
    })
}

/**
 * Gets the company version tiers based on the current tier version and variant
 */
export const getCompanyVersionTiers = ({
    currentTierVersion,
    variant,
}: {
    currentTierVersion: SubscriptionTierVersion | null
    variant: VariantType | null | undefined
}): CompanyTierDetail[] => {
    const tierDetails = getIsExistingCompanyVariant(variant)
        ? EXISTING_COMPANY_TIERS_DETAILS
        : NEW_COMPANY_TIERS_DETAILS

    if (currentTierVersion) return tierDetails[currentTierVersion]

    return []
}

/**
 * Checks if a given subscription tier is of type Company
 */
export const getIsCompanyTier = (subscriptionTier: SubscriptionTiers) =>
    subscriptionTier.includes(SubscriptionTierType.Companies)

export const getCompanyName = (company?: CompanyDTO) => company?.name || 'Tu empresa'
